// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {};

/**
 * [buildSuggestionProductPrice description]
 * @param  {[object]} data [description]
 */
BCSfFilter.prototype.buildSuggestionProductPrice = function(data) {
    /* Multi-currency Shopify */
    var self = this;
    self.prepareSuggestionProductPriceData(data);

    // Check on sale
    var onSale = data.compare_at_price_min > data.price_min;
    // Format price
    var price = this.formatMoney(data.price_min * 100),
        compareAtPrice = this.formatMoney(data.compare_at_price_min * 100);
    if (this.getSettingValue('search.removePriceDecimal')) {
        price = this.removeDecimal(price);
        compareAtPrice = this.removeDecimal(compareAtPrice);
    }
    // Build Price
    var result = '';
    var currency = Shopify.currency.active.toLowerCase();
    var metaPrice = checkCurrencyMetafield(currency, data.metafields);
    if (this.getSettingValue('search.showSuggestionProductPrice')) {
        result += '<div class="' + this.class.searchSuggestion + '-product-price">';
        if (onSale && this.getSettingValue('search.showSuggestionProductSalePrice')) {
            if (metaPrice != 0 && window.theme.region != "US") {
                // result += '<s>' + compareAtPrice + '</s>  ';
                result += '<span class="bc-sf-product-sale-price">' + metaPrice + '</span>';
            } else if (window.theme.region == "US") {
                result += '<s>' + compareAtPrice + '</s>  ';
                result += '<span class="bc-sf-product-sale-price">' + price + '</span>';
            } else {
                //display no price
                // result += '<s>' + compareAtPrice + '</s>  ';
                result += '<span class="bc-sf-product-sale-price"> </span>'
            }
        } else {
            if (metaPrice != 0 && window.theme.region != "US") {
                result += '<span class="bc-sf-product-regular-price">' + metaPrice + '</span>';
            } else if (window.theme.region == "US") {
                result += '<span class="bc-sf-product-regular-price">' + price +  '</span>';
            } else {
                //display no price
                result += '<span class="bc-sf-product-regular-price"></span>';
            }
        }
        result += '</div>';
    }
    return result;
};

function checkCurrencyMetafield(key, arr) {
    var priceValue = '0';

    for (var i = 0; i < arr.length; i++) {
        var pricing = arr[i];
        if (pricing.key == key) {
            priceValue = pricing.value;
            break;
        }
    }
    return priceValue;
}